import { render, staticRenderFns } from "./qn-foryuma2024.vue?vue&type=template&id=1da5bb9a&"
import script from "./qn-foryuma2024.vue?vue&type=script&lang=js&"
export * from "./qn-foryuma2024.vue?vue&type=script&lang=js&"
import style0 from "./qn-foryuma2024.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports